import NumberSelect from 'src/design/components/formSelect/NumberSelect';

const DayOfMonthSelect = ({ ...props }) => <NumberSelect min={1} max={31} defaultValueText="DD" {...props}/>;

export default DayOfMonthSelect;
